// import consts
import { PAGES, PAGE_IDS } from 'js/constants/Pages';

export const parseData = (data) => {
  const {
    home = {},
    vision_and_values = {},
    explore_porthole = {},
    about_the_show = {},
    navigation = {},
    meta = {},
    characters = {},
    social = {},
    cookie_policy = {},
    privacy_policy = {},
    terms_of_use = {},
    makes = {},
    watch = {},
    games = {},
  } = data.settings;

  const pages = {
    [PAGES[PAGE_IDS.home].id]: home,
    [PAGES[PAGE_IDS.vision_and_values].id]: vision_and_values,
    [PAGES[PAGE_IDS.characters].id]: characters,
    [PAGES[PAGE_IDS.explore_porthole].id]: explore_porthole,
    [PAGES[PAGE_IDS.about].id]: about_the_show,
    [PAGES[PAGE_IDS.terms].id]: terms_of_use,
    [PAGES[PAGE_IDS.cookie_policy].id]: cookie_policy,
    [PAGES[PAGE_IDS.privacy_policy].id]: privacy_policy,
    [PAGES[PAGE_IDS.terms].id]: terms_of_use,
    [PAGES[PAGE_IDS.make].id]: makes,
    [PAGES[PAGE_IDS.watch].id]: watch,
    [PAGES[PAGE_IDS.games].id]: games,
  };

  return {
    meta: meta,
    pages,
    navigation: navigation,
    characters: data.characters,
    locations: data.locations,
    makes: data.makes,
    games: data.games,
    videos: data.videos,
    social: { ...social.social },
    page_templates: data.articles,
  };
};
